import { Link, router } from '@inertiajs/react'
import { useState, type FormEvent } from 'react'
import SystemAdminLayout from '@/layouts/SystemAdminLayout'
import AdminPaginationBar from '@/components/AdminPaginationBar'
import type { AdminPagination } from '@/types'

interface UserRow {
  id: number
  email_address: string
  email_confirmed: boolean
  system_admin: boolean
  created_at: string
}

interface Props {
  users: UserRow[]
  pagination: AdminPagination
  q: string | null
}

export default function Index({ users, pagination, q }: Props) {
  const [search, setSearch] = useState(q ?? '')

  const submitSearch = (e: FormEvent) => {
    e.preventDefault()
    router.get('/system_admin/users', search ? { q: search } : {}, { preserveState: true })
  }

  return (
    <SystemAdminLayout>
      <div className="flex items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold">Users</h1>
          <p className="text-sm text-base-content/60">{pagination.total} total</p>
        </div>
        <form onSubmit={submitSearch} className="join">
          <input
            type="search"
            className="input input-sm join-item w-56"
            placeholder="Search by email…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button type="submit" className="btn btn-sm btn-primary join-item">
            <span className="iconify lucide--search size-4" />
          </button>
        </form>
      </div>

      <div className="card bg-base-100">
        <div className="card-body p-0">
          <table className="table">
            <thead><tr><th>Email</th><th>Status</th><th>Signed up</th></tr></thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id} className="hover:bg-base-200/50">
                  <td>
                    <Link href={`/system_admin/users/${u.id}`} className="link link-hover font-medium">{u.email_address}</Link>
                    {u.system_admin && <span className="badge badge-soft badge-warning badge-sm ms-2">staff</span>}
                  </td>
                  <td>
                    {u.email_confirmed
                      ? <span className="badge badge-soft badge-success badge-sm">confirmed</span>
                      : <span className="badge badge-soft badge-warning badge-sm">unconfirmed</span>}
                  </td>
                  <td className="text-sm">{new Date(u.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
              {users.length === 0 && (
                <tr><td colSpan={3} className="text-center text-base-content/40 py-8">No users match.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <AdminPaginationBar pagination={pagination} baseUrl="/system_admin/users" params={{ q: q ?? undefined }} />
    </SystemAdminLayout>
  )
}
